var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-group"},[_vm._l((_vm.items),function(val,i){return [(_vm.excludeId(val.id))?_c('div',{key:`recomrolls-${ i }`,staticClass:"card-group_item"},[_c('Card',{attrs:{"data":val,"type":_vm.type}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }